import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  cartItems: any[] = [];
  cartItemsLength: number = 0;
  subtotal: number = 0;
  total: number = 0;
  paymentMethod: string = 'card';
  isLoading: boolean = false;
  guestMode: boolean = false;
  
  couponApplied: boolean = false;
  couponType: string = 'percentage'; // Can be 'percentage' or 'fixed'
  couponValue: number = 0; // Either percentage (e.g., 15) or fixed amount (e.g., 5)
  couponCode: string = '';
  couponCodeForm: FormGroup

  constructor(
    private apiService: ApiService,
    private alertService: AlertService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.couponCodeForm = this.fb.group({
      code: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('bbq_token')?.toString();
    const couponApplied = localStorage.getItem('couponApplied');
    if(token){
      this.getCartItems()
    }else if(guestMode){
      this.guestMode = true;
      this.loadGuestCart();
    }else{
      this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to view your cart');
    }

    if(couponApplied){
      this.couponApplied = true;
      this.couponValue = parseFloat(localStorage.getItem('couponValue'));
      this.couponCode = localStorage.getItem('couponCode');
      this.couponType = localStorage.getItem('couponType');
      this.calculateTotals();
    }

    localStorage.setItem('paymentMethod', this.paymentMethod);
  }

  changePayment(payment: string){
    this.paymentMethod = payment;
    localStorage.setItem('paymentMethod', this.paymentMethod);
  }

  loadGuestCart() {
    this.isLoading = true;
    const cartItems = sessionStorage.getItem('cartItems');
    if (cartItems) {
      this.cartItems = JSON.parse(cartItems);
      
      // Ensure backward compatibility - add selectedTypeName if missing
      this.cartItems = this.cartItems.map(item => {
        if (!item.selectedTypeName && item.type_name) {
          item.selectedTypeName = item.type_name;
        }
        if (!item.selectedExtraId && item.extra_ids) {
          item.selectedExtraId = item.extra_ids;
        }
        return item;
      });
      
      this.cartItemsLength = this.cartItems.length;
      this.calculateTotals();
    }
    this.isLoading = false;
  }
  getCartItems() {
    this.isLoading = true;
    this.apiService.getCart().subscribe({
      next: response => {
        this.cartItems = response.data;
        this.cartItemsLength = this.cartItems.length;
        this.calculateTotals();
        this.isLoading = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.isLoading = false;
      }
    });
  }

  saveGuestCart() {
    const guestCart = this.cartItems.map(item => ({
        id: item.id || item.product_id,
        name: item.name,
        avatar: item.avatar,
        offer: item.offer || null,
        rate: item.rate || 0,
        components: item.components,
        types: item.types,
        extraproducts: item.extraproducts || [],
        selectedTypeId: item.selectedTypeId,
        selectedExtraId: item.selectedExtraId || item.selectedExtraIds || [], // Use selectedExtraId to match backend
        quantity: item.quantity,
        category_name: item.category_name || item.categoryName || 'Menu',
        // Include price for easy access if needed
        price: item.price || this.getOriginalItemPrice(item),
        // Include free sides if available
        side: item.side || [],
        free_side_count: item.free_side_count || item.free_side || 0
    }));
    
    sessionStorage.setItem('cartItems', JSON.stringify(guestCart));
    console.log('Guest cart saved:', guestCart);
  }

  refreshCartItems() {
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('bbq_token')?.toString();
    if(token){
      this.apiService.getCart().subscribe({
        next: response => {
          this.cartItems = response.data;
          this.cartItemsLength = this.cartItems.length;
          this.calculateTotals();
        }, 
        error: (error: any) => {
          this.alertService.danger(error.error.message);
        }
      });
    }else if(guestMode){
      this.loadGuestCart();
    }else{
      this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to view your cart');
    }
  }

  // getItemPrice(item: any): number {
  //   // 1. Get base price from selected type
  //   const selectedType = item.types.find((type: any) => type.id === item.selectedTypeId);
  //   const basePrice = selectedType ? selectedType.price : item.types[0].price;
    
  //   // 2. Calculate extras price for this single item
  //   let extrasPrice = 0;
  //   if (item.selectedExtraId && item.selectedExtraId.length > 0) {
  //     const extraIds = typeof item.selectedExtraId === 'string' 
  //       ? JSON.parse(item.selectedExtraId) 
  //       : item.selectedExtraId;
  //     extrasPrice = item.extraproducts
  //       .filter((extra: any) => extraIds.includes(extra.id))
  //       .reduce((sum: number, extra: any) => sum + extra.price, 0);
  //   }
    
  //   // Return total price for this single item (base + extras)
  //   return basePrice + extrasPrice;
  // }

// getExtraName(item: any, extraId: number): string {
//   try {
//     // First try to find in item.extra array
//     if (item && item.extra && Array.isArray(item.extra)) {
//       const extra = item.extra.find((e: any) => e.id == extraId);
//       if (extra && extra.name) {
//         return extra.name;
//       }
//     }
    
//     // Fallback: try item.extraproducts (if it exists)
//     if (item && item.extraproducts && Array.isArray(item.extraproducts)) {
//       const extra = item.extraproducts.find((e: any) => e.id == extraId);
//       if (extra && extra.name) {
//         return extra.name;
//       }
//     }
    
//     // Final fallback
//     return `Extra #${extraId}`;
//   } catch (error) {
//     console.error('Error getting extra name:', error);
//     return 'Extra';
//   }
// }
  getUniqueExtrasWithCount(item: any): any[] {
    if (!item || !item.selectedExtraId || !Array.isArray(item.selectedExtraId)) {
        return [];
    }
    
    // Count occurrences of each extra ID
    const countMap = new Map<number, number>();
    item.selectedExtraId.forEach((id: number) => {
        countMap.set(id, (countMap.get(id) || 0) + 1);
    });
    
    // Create array of unique extras with counts and names
    const uniqueExtras: any[] = [];
    countMap.forEach((count, id) => {
        const extraInfo = this.getExtraInfo(item, id);
        if (extraInfo) {
            uniqueExtras.push({
                id: id,
                name: extraInfo.name,
                count: count
            });
        }
    });
    
    return uniqueExtras;
  }

  // Helper function to get extra info by ID
  getExtraInfo(item: any, extraId: number): any {
    if (!item || !item.extraproducts || !Array.isArray(item.extraproducts)) {
        return null;
    }
    return item.extraproducts.find((e: any) => e.id == extraId) || null;
  }

  // Keep the original getExtraName function for other uses if needed
  getExtraName(item: any, extraId: number): string {
    try {
        // Count how many times this extraId appears in selectedExtraId array
        if (item && item.selectedExtraId && Array.isArray(item.selectedExtraId)) {
            const count = item.selectedExtraId.filter((id: number) => id === extraId).length;
            
            // Find the extra name from extraproducts
            if (item.extraproducts && Array.isArray(item.extraproducts)) {
                const extra = item.extraproducts.find((e: any) => e.id == extraId);
                if (extra && extra.name) {
                    // Return with quantity if count is greater than 1
                    if (count > 1) {
                        return `${extra.name} (${count}x)`;
                    }
                    return extra.name;
                }
            }
        }
        
        // Final fallback
        return `Extra #${extraId}`;
    } catch (error) {
        console.error('Error getting extra name:', error);
        return 'Extra';
    }
  }


  updateCartItem(index: number) {
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('bbq_token')?.toString();
    const item = this.cartItems[index];
    let extras: any[] = [];
    if(item.selectedExtraId.length > 0){
      extras = item.extraproducts.filter(extra => item.selectedExtraId.includes(extra.id));
    }else{
      extras = [];
    }
    const freeSideIds = item.selectedFreeSides.map(side => side.id);
    // Prepare the request body in the required format
    const body = {
      products: [
        {
          product_id: item.id,
          type: item.selectedTypeId,
          quantity: item.quantity,
          extra: item.selectedExtraId, // item.extraproducts.map(extra => extra.id) || [] // Include extras
          side: freeSideIds
        }
      ]
    };
    console.log('Sending update:', body); // For debugging

    if(token){
      this.apiService.addToCart(body).subscribe({
        next: () => {
          this.calculateTotals();
          this.refreshCartItems(); // Refresh cart to ensure sync with server
          this.alertService.success('Cart updated successfully');
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to update cart');
          this.refreshCartItems(); // Revert changes by refreshing from server
        }
      });
    }else if(guestMode){
      this.saveGuestCart();
      this.calculateTotals();
      // this.alertService.success('Cart updated');
    }else{
      this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to view your cart');
    }
  }

  increaseQuantity(index: number) {
    this.cartItems[index].quantity++;
    const guestMode = sessionStorage.getItem('guestMode');
    if(guestMode){
      // this.cartItems[index].quantity++;
      this.saveGuestCart();
      this.calculateTotals();
      this.alertService.success('Cart updated');
    }
    this.updateCartItem(index);
  }

  decreaseQuantity(index: number) {
    if (this.cartItems[index].quantity > 1) {
      this.cartItems[index].quantity--;
      const guestMode = sessionStorage.getItem('guestMode');
      if(guestMode){
        // this.cartItems[index].quantity++;
        this.saveGuestCart();
        this.calculateTotals();
        this.alertService.success('Cart updated');
      }
      this.updateCartItem(index);
    } else {
      // Optional: Ask for confirmation before removing item when quantity reaches 0
      if (confirm('Remove this item from cart?')) {
        this.removeItem(index);
      } else {
        // Keep quantity at 1 if user cancels
        this.cartItems[index].quantity = 1;
      }
    }
  }

  removeItem(index: number) {
    const itemId = this.cartItems[index].id;
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('bbq_token')?.toString();
    
    if(token){
      this.apiService.removeCartItem(itemId).subscribe({
        next: () => {
          this.cartItems.splice(index, 1);
          this.cartItemsLength = this.cartItems.length;
          this.getCartItems()
          this.calculateTotals();
          this.alertService.success('Item removed from cart');
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to remove item');
        }
      });
    }else if(guestMode){
      this.cartItems.splice(index, 1);
      this.cartItemsLength = this.cartItems.length;
      this.saveGuestCart();
      this.calculateTotals();
      this.alertService.success('Item removed from cart');
    }else{
      this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to view your cart');
    }
  }

  // calculateTotals() {
  //     // Calculate subtotal
  //     this.subtotal = this.cartItems.reduce((sum, item) => {
  //         return sum + (this.getItemPrice(item) * item.quantity);
  //     }, 0);
      
  //     // Calculate coupon discount
  //     let discountAmount = 0;
  //     if (this.couponApplied) {
  //         discountAmount = this.couponType === 'percentage'
  //             ? this.subtotal * (this.couponValue / 100)
  //             : Math.min(this.couponValue, this.subtotal); // Don't discount more than subtotal
  //     }
      
  //     // Calculate final total
  //     this.total = this.subtotal - discountAmount;
      
  //     // Ensure total is never negative
  //     this.total = Math.max(0, this.total);
  // }

  getOriginalItemPrice(item: any): number {
    if (!item.selectedTypeId && item.types?.length) {
        return item.types[0].price;
    }
    
    const selectedType = item.types?.find(t => t.id === item.selectedTypeId);
    return selectedType?.price || item.price || 0;
}

getItemPrice(item: any): number {
    const basePrice = this.getOriginalItemPrice(item);
    
    // Calculate extras price using the new selectedExtraId format (objects with quantity)
    let extrasPrice = 0;
    if (item.selectedExtraId && Array.isArray(item.selectedExtraId)) {
        extrasPrice = item.selectedExtraId.reduce((total: number, extra: any) => {
            return total + (extra.price * extra.quantity);
        }, 0);
    }
    
    // Calculate free sides price
    let freeSidesPrice = 0;
    if (item.selectedFreeSides && Array.isArray(item.selectedFreeSides)) {
        freeSidesPrice = item.selectedFreeSides.reduce((total: number, side: any) => {
            return total + (side.price || 0);
        }, 0);
    }
    
    const totalBasePrice = basePrice + extrasPrice + freeSidesPrice;
    
    if (!item.offer) return totalBasePrice;
    
    if (item.offer.type === 'discount') {
        return Math.max(0, totalBasePrice - item.offer.value);
    } 
    else if (item.offer.type === 'percentage') {
        return totalBasePrice * (1 - item.offer.value / 100);
    }
    
    return totalBasePrice;
}

// Helper function to get total price for the item (unit price * quantity)
getItemTotalPrice(item: any): number {
    return this.getItemPrice(item) * item.quantity;
}

// Remove or update these functions since they're no longer needed with the new format
// getUniqueExtrasWithCount() - No longer needed
// getExtraInfo() - No longer needed  
// getExtraName() - No longer needed

getItemDiscountText(item: any): string {
    if (!item.offer) return '';
    
    if (item.offer.type === 'discount') {
        return `Save $${item.offer.value}`;
    }
    else if (item.offer.type === 'percentage') {
        return `${item.offer.value}% off`;
    }
    
    return '';
}


  cartDiscount: any

  calculateDiscountedPrice2(item: any, price: number): number {
      if (!item.offer) return price;
      
      if (item.offer.type === 'discount') {
          return Math.max(0, price - item.offer.value);
      } 
      else if (item.offer.type === 'percentage') {
          return price * (1 - item.offer.value / 100);
      }
      
      return price;
  }

  // calculateTotals() {
  //     // Calculate subtotal and cart discount
  //     let subtotal = 0;
  //     let cartDiscount = 0;
      
  //     this.cartItems.forEach(item => {
  //         // Get base price (similar to menu component logic)
  //         const basePrice = this.getOriginalItemPrice(item);
          
  //         // Calculate extras total for this item (similar to menu component)
  //         let extrasTotal = 0;
  //         if (item.selectedExtraId && Array.isArray(item.selectedExtraId) && item.extraproducts) {
  //             // Count quantities for each extra (since selectedExtraId has duplicates for quantity)
  //             const extraQuantities = new Map<number, number>();
  //             item.selectedExtraId.forEach(extraId => {
  //                 extraQuantities.set(extraId, (extraQuantities.get(extraId) || 0) + 1);
  //             });
              
  //             // Calculate extras total
  //             extraQuantities.forEach((quantity, extraId) => {
  //                 const extra = item.extraproducts.find((e: any) => e.id === extraId);
  //                 if (extra && extra.price) {
  //                     extrasTotal += extra.price * quantity;
  //                 }
  //             });
  //         }
          
  //         // Calculate unit price (base + extras)
  //         const unitPrice = basePrice + extrasTotal;
          
  //         // Apply item-level discount if exists (similar to menu component)
  //         let discountedUnitPrice = unitPrice;
  //         if (item.offer) {
  //             discountedUnitPrice = this.calculateDiscountedPrice2(item, unitPrice);
  //         }
          
  //         // Calculate item total
  //         const itemTotal = discountedUnitPrice * item.quantity;
  //         const originalItemTotal = unitPrice * item.quantity;
          
  //         subtotal += itemTotal;
  //         cartDiscount += (originalItemTotal - itemTotal);
  //     });
      
  //     this.subtotal = subtotal;
  //     this.cartDiscount = cartDiscount;
      
  //     // Calculate coupon discount
  //     let couponDiscount = 0;
  //     if (this.couponApplied) {
  //         couponDiscount = this.couponType === 'percentage'
  //             ? this.subtotal * (this.couponValue / 100)
  //             : Math.min(this.couponValue, this.subtotal);
  //     }
      
  //     // Calculate final total
  //     this.total = Math.max(0, this.subtotal - couponDiscount);
      
  //     console.log('Cart Totals:', {
  //         subtotal: this.subtotal,
  //         cartDiscount: this.cartDiscount,
  //         couponDiscount: couponDiscount,
  //         total: this.total
  //     });
  // }
  calculateTotals() {
    let subtotal = 0;
    let cartDiscount = 0;
    
    this.cartItems.forEach(item => {
        const itemTotal = this.getItemTotalPrice(item);
        subtotal += itemTotal;
        
        // Calculate discount for display purposes
        const originalPrice = this.getOriginalItemPrice(item);
        const discountedPrice = this.getItemPrice(item);
        const originalTotal = originalPrice * item.quantity;
        const discountedTotal = discountedPrice * item.quantity;
        cartDiscount += (originalTotal - discountedTotal);
    });
    
    this.subtotal = subtotal;
    this.cartDiscount = cartDiscount;
    
    // Calculate coupon discount
    let couponDiscount = 0;
    if (this.couponApplied) {
        couponDiscount = this.couponType === 'percentage'
            ? this.subtotal * (this.couponValue / 100)
            : Math.min(this.couponValue, this.subtotal);
    }
    
    // Calculate final total
    this.total = Math.max(0, this.subtotal - couponDiscount);
    
    console.log('Cart Totals:', {
        subtotal: this.subtotal,
        cartDiscount: this.cartDiscount,
        couponDiscount: couponDiscount,
        total: this.total
    });
  }


  coponType: string = '';
  applyCoupon() {
    if (!this.couponCode) {
        this.alertService.danger('Please enter a coupon code');
        return;
    }

    const token = localStorage.getItem('bbq_token')?.toString();
    const guestMode = sessionStorage.getItem('guestMode');
    
    if (token) {
        this.couponCodeForm.patchValue({ code: this.couponCode });
        this.apiService.applyCoupon(this.couponCodeForm.value).subscribe({
            next: (response) => {
                if (response.status) {
                    this.couponApplied = true;
                    this.couponType = response.copon_type; // 'percentage' or 'fixed'
                    this.couponValue = parseFloat(response.copon_value); // Convert string to number
                    if(response.status == true){
                      this.alertService.success('Coupon applied successfully');
                      localStorage.setItem('couponApplied', 'true');
                      localStorage.setItem('couponId', response.copon_id);
                      localStorage.setItem('couponType', this.couponType);
                      localStorage.setItem('couponValue', this.couponValue.toString());
                      localStorage.setItem('couponCode', this.couponCode);
                      this.calculateTotals();
                    }
                } else {
                    this.alertService.danger('Invalid coupon code');
                }
            },
            error: (error) => {
                this.alertService.danger(error.error?.message || 'Failed to apply coupon');
            }
        });
    } else if (guestMode) {
      this.couponCodeForm.patchValue({ code: this.couponCode });
      this.apiService.applyCoupon(this.couponCodeForm.value).subscribe({
        next: (response) => {
          if (response.status) {
            this.couponApplied = true;
            this.couponType = response.copon_type; // 'percentage' or 'fixed'
            this.couponValue = parseFloat(response.copon_value); // Convert string to number
            if(response.status == true){
              this.alertService.success('Coupon applied successfully');
              localStorage.setItem('couponApplied', 'true');
              localStorage.setItem('couponType', this.couponType);
              localStorage.setItem('couponId', response.copon_id);
              localStorage.setItem('couponValue', this.couponValue.toString());
              localStorage.setItem('couponCode', this.couponCode);
              this.calculateTotals();
            }
          } else {
            this.alertService.danger('Invalid coupon code');
          }
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to apply coupon');
        }
      });
    } else {
        this.alertService.danger('You must be logged in to apply a coupon');
    }
  }

  handleGuestCart(selectedType: any, selectedExtraIds: number[]) {
    // const guestCart = JSON.parse(sessionStorage.getItem('cartItems') || '[]');

    // const newCartItem = {
    //     id: guestCart.id, // Added for consistency
    //     product_id: this.selectedProduct.id,
    //     name: this.selectedProduct.name,
    //     avatar: this.selectedProduct.avatar,
    //     types: this.selectedProduct.types,
    //     extraproducts: this.selectedProduct.extraproducts,
    //     selectedTypeId: selectedType.id,
    //     selectedExtraIds: selectedExtraIds, // Store as array
    //     quantity: this.quantity,
    //     price: selectedType.price,
    // };

    // guestCart.push(newCartItem);
    // sessionStorage.setItem('cartItems', JSON.stringify(guestCart));
    // this.alertService.success('Item added to cart!');
  }

  proceedToCheckout() {
    if (this.cartItemsLength === 0) {
      this.alertService.danger('Your cart is empty');
      return;
    }else{
      this.router.navigate(['/checkout']);
    }

    // const orderData = {
    //   items: this.cartItems.map(item => ({
    //     product_id: item.id,
    //     type_id: item.selectedTypeId,
    //     quantity: item.quantity
    //   })),
    //   payment_method: this.paymentMethod,
    //   coupon_code: this.couponApplied ? this.couponCode : null
    // };

    // this.apiService.confirmOrder(orderData).subscribe({
    //   next: (response) => {
    //     this.alertService.success('Order placed successfully');
    //     // Redirect to order confirmation or clear cart
    //     this.cartItems = [];
    //     this.cartItemsLength = 0;
    //     this.calculateTotals();
    //   },
    //   error: (error) => {
    //     this.alertService.danger(error.error?.message || 'Failed to place order');
    //   }
    // });
  }

  removeCoupon(){
    localStorage.removeItem('couponApplied')
    localStorage.removeItem('couponValue')
    localStorage.removeItem('couponCode')
    localStorage.removeItem('couponType')
    localStorage.removeItem('couponId')
    this.couponCode = ''
    this.couponApplied = false
    this.couponValue = 0
    this.calculateTotals()
  }
}